import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function IntroAnimation({
  onComplete
}: {
  onComplete: () => void;
}) {
  const [isVisible, setIsVisible] = useState(true);
  const {
    t
  } = useLanguage();
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onComplete, 800); // Wait for exit animation to finish
    }, 2200); // Total display time before exit
    return () => clearTimeout(timer);
  }, [onComplete]);
  return <AnimatePresence data-id="element-152">
      {isVisible && <motion.div initial={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: '-100%'
    }} transition={{
      duration: 0.8,
      ease: [0.76, 0, 0.24, 1]
    }} className="fixed inset-0 z-[9999] bg-black flex flex-col items-center justify-center overflow-hidden" data-id="element-153">
          <div className="flex flex-col items-center" data-id="element-154">
            <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex flex-col items-center justify-center mb-8 gap-5" data-id="element-155">
              <img src="https://cdn.magicpatterns.com/uploads/9mEgRo94BdLBoXFgduhDkY/logo.png" alt="Elias Navarro Law Logo" className="h-24 w-auto object-contain" data-id="element-156" />
              <div className="flex flex-col items-center leading-none" data-id="element-157">
                <span className="font-serif text-[22px] font-bold tracking-[6px] text-white uppercase" data-id="element-158">
                  Elias Navarro
                </span>
                <span className="text-[10px] tracking-[8px] text-gold-light uppercase font-light mt-2" data-id="element-159">
                  Law Firm
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
          width: 0
        }} animate={{
          width: 200
        }} transition={{
          duration: 0.6,
          delay: 0.6,
          ease: 'easeInOut'
        }} className="h-px bg-crimson mb-6" data-id="element-160" />

            <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: 1.2
        }} className="text-[9px] tracking-[6px] uppercase text-[#f5f5f5]/40 font-medium" data-id="element-161">
              {t('splash.loading')}
            </motion.div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}